import moment from 'moment';

const columnConfig = [
  {
    title: 'clients.date',
    // eslint-disable-next-line new-cap -- FIXME
    accessor: row => new moment(row.createdAt).format('DD.MM.YYYY'),
    name: 'createdAt',
    filterable: false,
    sortable: false,
    width: 100,
  },
  {
    title: 'clients.phone',
    accessor: 'data',
    name: 'data',
    filterable: false,
    sortable: false,
    width: 150,
  },
  {
    title: 'comments.content',
    accessor: 'content',
    name: 'content',
    filterable: false,
    sortable: false,
  },
];

export default columnConfig;
